/* istanbul ignore file */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import {createStore} from '@vfde-sails/core';
import {trackingMiddleware} from '@vfde-sails/tracking';
import GlasfaserRegistration from './container/glasfaserRegistration';

createStore({},[trackingMiddleware]);
GlasfaserRegistration();
